module.exports = __webpack_public_path__ + "media/images/icon-link-91ca81385eaac186a24654c7554b1fc4.svg";